/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_ClientInputs */

const cs_viewings_client = /** @type {(inputs: Viewings_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient`)
};

const en_viewings_client = /** @type {(inputs: Viewings_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client`)
};

/**
* | output |
* | --- |
* | "Client" |
*
* @param {Viewings_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_client = /** @type {((inputs?: Viewings_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_client(inputs)
	return cs_viewings_client(inputs)
});